import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

import {
  adminMenuItems,
  teacherMenuItems,
  studentMenuItems,
} from "config/menuConfig";

import "styles/panel.css";
import { FaRegUser } from "react-icons/fa";
import { BiLogOutCircle } from "react-icons/bi";

const PanelNavbar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  const user = {
    name: localStorage.getItem("userName") || "Foydalanuvchi",
    role: (localStorage.getItem("userRole") || "guest").toLowerCase(),
  };

  const getMenuItems = () => {
    switch (user.role) {
      case "teacher":
        return teacherMenuItems;
      case "student":
        return studentMenuItems;
      default:
        return adminMenuItems;
    }
  };

  const getCurrentPageTitle = () => {
    const menu = getMenuItems();
    const matched = menu.find((item) =>
      location.pathname.startsWith(item.path)
    );
    return matched ? matched.name : "Panel";
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/login", { replace: true });
  };

  const displayedTitle = () => {
    if (location.pathname === "/profile") {
      return "← Orqaga";
    }
    return getCurrentPageTitle();
  };

  const handleBack = () => {
    if (location.pathname === "/profile") {
      navigate(-1);
    }
  };

  const dropdownVariants = {
    hidden: { opacity: 0, scale: 0.96, y: -8, transformOrigin: "top right" },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: { type: "spring", stiffness: 400, damping: 25 },
    },
    exit: { opacity: 0, scale: 0.96, y: -8, transition: { duration: 0.16 } },
  };

  return (
    <header className="panel_navbar">
      <h3
        className="panel_navbar-title"
        onClick={handleBack}
        style={{
          cursor: location.pathname === "/profile" ? "pointer" : "default",
          userSelect: "none",
        }}
      >
        {displayedTitle()}
      </h3>

      <div className="profile-wrapper" ref={dropdownRef}>
        <div
          className="profile"
          onClick={() => setIsOpen(!isOpen)}
          role="button"
          tabIndex={0}
        >
          <img
            src="https://i.pravatar.cc/40"
            alt="Profil rasmi"
            className="avatar"
            loading="lazy"
          />
          <div className="profile-info">
            <p className="name">{user.name}</p>
            <p className="role">
              {user.role.charAt(0).toUpperCase() + user.role.slice(1)}
            </p>
          </div>
        </div>

        <AnimatePresence>
          {isOpen && (
            <motion.div
              className={`profile-dropdown ${isOpen ? "active" : ""}`}
              variants={dropdownVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
            >
              <div className="dropdown-content">
                <button
                  className="dropdown-item"
                  onClick={() => {
                    setIsOpen(false);
                    navigate("/profile");
                  }}
                >
                  <FaRegUser size={12} />
                  Profil
                </button>

                <button className="dropdown-item logout" onClick={handleLogout}>
                  <BiLogOutCircle size={12} />
                  Chiqish
                </button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </header>
  );
};

export default PanelNavbar;
